module.exports = __webpack_public_path__ + "static/img/empty-bg.bebc70a1.png";